export const ENTRIES = {
    index: "entries.index",
    view: "entries.view-entry",
}

export const BOOTHS = {
    feed: "booths.feed",
    homescreen: "booths.homescreen",
}

export const CYCLES = {
    index: "cycles.index",
    cycle: "cycles.cycle",
}

export const TIME_MAPPING = {
    index: "time-mapping.index",
}

export const ROADMAPS = {
    index: "roadmaps.index",
    roadmap: "roadmaps.roadmap",
}

export default {
    ENTRIES,
    BOOTHS,
    CYCLES,
    TIME_MAPPING,
    ROADMAPS,
};